import React from 'react';
import { useIntl } from 'react-intl';

const HowToPlay = () => {
  const intl = useIntl();

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-indigo-800 mb-6">
        {intl.formatMessage({ id: 'howToPlay.title' })}
      </h1>
      <ol className="list-decimal list-inside space-y-4 mb-8">
        {[1, 2, 3, 4, 5, 6, 7].map((num) => (
          <li key={num} className="text-lg">
            {intl.formatMessage({ id: `howToPlay.steps.${num}` })}
          </li>
        ))}
      </ol>

      <h2 className="text-2xl font-bold text-indigo-700 mb-4">
        {intl.formatMessage({ id: 'howToPlay.tipsTitle' })}
      </h2>
      <ul className="list-disc list-inside space-y-3 mb-8">
        {[1, 2, 3, 4, 5, 6].map((num) => (
          <li key={num} className="text-lg">
            {intl.formatMessage({ id: `howToPlay.tips.${num}` })}
          </li>
        ))}
      </ul>

      <h2 className="text-2xl font-bold text-indigo-700 mb-4">
        {intl.formatMessage({ id: 'howToPlay.advancedTitle' })}
      </h2>
      <ul className="list-disc list-inside space-y-3">
        {[1, 2, 3, 4, 5].map((num) => (
          <li key={num} className="text-lg">
            {intl.formatMessage({ id: `howToPlay.advanced.${num}` })}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default HowToPlay;